/**
 * Aggregator for tactics-related Brain tools. Each phase of the
 * tactics-hub roadmap owns its own tool module; this file unions
 * them so `brainTools.ts` can pull them in with one import. Avoids
 * the "many agents editing brainTools.ts" merge-conflict pattern.
 *
 * Roadmap mapping (docs/scope/tactics-hub-roadmap.md):
 *   Phase 1 → tacticsTools           (draft + critique)
 *   Phase 2 → tacticsSequenceTools   (multi-keyframe + branches)
 *   Phase 3 → tacticsAnnotationTools (zones + coaching points + voice-overs)
 *   Phase 4 → tacticsPatternTools    (library + roster overlay)
 */
import { TACTICS_TOOLS as PHASE1_TOOLS } from './tacticsTools';
import { TACTICS_SEQUENCE_TOOLS } from './tacticsSequenceTools';
import { TACTICS_ANNOTATION_TOOLS } from './tacticsAnnotationTools';
import { TACTICS_PATTERN_TOOLS } from './tacticsPatternTools';
import { PLAYER_BRIEFS_TOOLS } from './playerBriefsTools';

export const ALL_TACTICS_TOOLS = [
  ...PHASE1_TOOLS,
  ...TACTICS_SEQUENCE_TOOLS,
  ...TACTICS_ANNOTATION_TOOLS,
  ...TACTICS_PATTERN_TOOLS,
  ...PLAYER_BRIEFS_TOOLS,
];

export { critiqueTactics, applyTacticsDraft } from './tacticsTools';
export {
  applyAnnotationDraft,
  summariseTacticsLayout,
  TACTICS_ANNOTATION_TOOL_NAMES,
  type CoachScript,
  type CoachScriptKeyframe,
  type TacticsAnnotationDraftInput,
} from './tacticsAnnotationTools';
export {
  dispatchPatternTool,
  TACTICS_PATTERN_TOOL_NAMES,
  type TacticsPatternStore,
  type TacticsPatternRow,
  type TacticsPatternListFilter,
  type TacticsPatternPhase,
  type TacticsPatternSource,
} from './tacticsPatternTools';
export {
  dispatchPlayerBriefsTool,
  PLAYER_BRIEFS_TOOL_NAMES,
  type PlayerBriefsDraftInput,
  type PlayerBriefsDraftPayload,
} from './playerBriefsTools';
